import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Outlet } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ProviderPresentationMode } from 'widgets/PresentationMode/context/presentationModeContext'
import { PresentationModeStore } from 'widgets/PresentationMode/store/presentationModeStore'

export const PresentationModeLayout = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new PresentationModeStore(entities))

  return (
    <ProviderPresentationMode value={store}>
      <Outlet />
    </ProviderPresentationMode>
  )
})
